import { Action, createReducer, on } from '@ngrx/store';
import * as paymentActions from './payments.actions';
import { PaymentsState } from './payments.state';
import * as appActions from '@store/app/app.actions';

export const initialCustomer: PaymentsState = {
  paymentResponse: null,
  error: null,
  isLoadingPayments: null,
  createCardToken: null,
  paymentParams: null,
  creditCard: null,
  deviceSessionId: null,
};

const _paymentsReducer = createReducer(
  initialCustomer,
  on(paymentActions.createPayments, (state) => {
    return {
      ...state,
      error: false,
    };
  }),
  on(paymentActions.successCreatePayments, (state, { paymentResponse }) => {
    return {
      ...state,
      paymentResponse,
      isLoadingPayments: true,
      error: false,
    };
  }),
  on(paymentActions.failureCreatePayments, (state) => {
    return {
      ...state,
      isLoadingPayments: false,
      error: true,
    };
  }),
  on(paymentActions.createCardToken, (state, { paymentParams }) => {
    return {
      ...state,
      paymentParams,
      isLoadingPayments: true,
      error: false,
    };
  }),
  on(paymentActions.successCreateCardToken, (state, { creditCard }) => {
    return {
      ...state,
      creditCard,
      error: false,
    };
  }),
  on(paymentActions.setDeviceSessionId, (state, { deviceSessionId }) => {
    return {
      ...state,
      deviceSessionId,
    };
  }),
  on(paymentActions.createPaymentIfHasCard, (state, { paymentParams }) => {
    return {
      ...state,
      paymentParams,
      isLoadingPayments: true,
      error: false,
    };
  }),
  on(paymentActions.setPaymentsParams, (state, { paymentParams }) => {
    return {
      ...state,
      paymentParams,
    };
  }),
  on(paymentActions.setIsLoadingPayment, (state, { isLoading }) => {
    return {
      ...state,
      isLoadingPayments: isLoading,
    };
  }),
  on(paymentActions.open3dsRedirection, (state, { paymentResponse }) => {
    return {
      ...state,
      paymentResponse,
      isLoadingPayments: true,
      error: false,
    };
  }),
  on(paymentActions.setLoading, (state, { isLoadingPayments }) => {
    return {
      ...state,
      isLoadingPayments,
    };
  }),
  on(appActions.setRedirectUrl, (state) => {
    return {
      ...state,
      isLoadingPayments: false,
    };
  })
);

export function paymentsReducers(state: PaymentsState | undefined, action: Action) {
  return _paymentsReducer(state, action);
}
